<template>
    <div>
        <van-nav-bar title="筛选" left-text="返回" left-arrow @click-left="onClickLeft" />
        <div class="header">
            <div class="province" @click="showProvince">
                <span>{{$store.state.areaInfo.province}}</span>
                <Icon :type="isArea?'ios-arrow-up':'ios-arrow-down'" />
            </div>
            <div class="province" @click="showType">
                <span>{{$store.state.type.institution_name}}</span>
                <Icon :type="isType?'ios-arrow-up':'ios-arrow-down'" />
            </div>
            <div class="province" @click="showPici">
                <span>{{$store.state.type.disciplinary_name}}</span>
                <Icon :type="isPici?'ios-arrow-up':'ios-arrow-down'" />
            </div>
        </div>
        <van-list v-model="loading" :finished="finished">
            <div class="school-list" v-if="schoolList.length>0">
                <div
                    v-for="(item,index) in schoolList"
                    :key="item.id"
                    style="margin-bottom: 1.3rem"
                >
                    <div class="school-item">
                        <div class="show-more">
                            <Icon type="ios-apps" />
                        </div>

                        <div class="school-info" @click="goSchoolDetail(item)">
                            <div class="school-logo">
                                <img :src="item.logo" />
                            </div>
                            <div class="school-name">
                                <div class="title">{{item.name}}</div>
                                <div class="batch">
                                    <span>{{item.city}}</span>
                                    <span>{{item.institution_type[0]}}</span>
                                    <span>{{item.disciplinary_level}}</span>
                                </div>
                            </div>
                            <div class="type">
                                <span>{{item.labe_id}}</span>
                            </div>
                        </div>
                        <div class="more" @click="showMore(item,index)">
                            <Icon
                                :type="item.isOpen?'ios-arrow-up':'ios-arrow-down'"
                                style="font-size:20px"
                            />
                        </div>
                    </div>
                    <div class="more-info" v-if="item.isOpen">
                        <p>收藏次数:{{item.shoucang}}</p>
                    </div>
                </div>
            </div>
            <div v-else class="noPost">抱歉，暂无数据!!!</div>
        </van-list>
        <!-- 省份弹窗 -->
        <div class="area" v-if="isArea">
            <div
                :class="item.id === $store.state.type.institution_type?'area-province-on':'area-province' "
                v-for="(item,index) in areaList"
                :key="index"
                @click="chooseCity(item)"
            >{{item.name}}</div>
        </div>
        <!-- 类型弹窗 -->
        <div class="area" v-if="isType">
            <div
                :class="item.id === $store.state.type.institution_type?'area-province-on':'area-province' "
                v-for="(item,index) in typeList"
                :key="index"
                @click="chooseType(item)"
            >{{item.name}}</div>
        </div>
        <!-- 批次弹窗 -->
        <div class="area" v-if="isPici">
            <div
                :class="item.id === $store.state.type.disciplinary_level?'area-province-on':'area-province' "
                v-for="(item,index) in pici"
                :key="index"
                @click="choosePici(item)"
            >{{item.name}}</div>
        </div>
    </div>
</template>

<script>
import { httpPost } from "../../axios/index";

export default {
    data() {
        return {
            list: [],
            loading: false,
            finished: true,
            isArea: false,
            isType: false,
            isPici: false,
            schoolList: [],
            areaList: [],
            typeList: [],
            pici: [
                {
                    id: 1,
                    name: "一本"
                },
                {
                    id: 2,
                    name: "二本"
                },
                {
                    id: 4,
                    name: "专科"
                }
            ]
        };
    },
    methods: {
        // 弹框显示隐藏效果
        showProvince() {
            this.isArea = !this.isArea;
            this.isType = false;
            this.isPici = false;
        },
        showType() {
            this.isType = !this.isType;
            this.isPici = false;
            this.isArea = false;
        },
        showPici() {
            this.isPici = !this.isPici;
            this.isType = false;
            this.isArea = false;
        },
        // 选择城市
        chooseCity(item) {
          
            this.$store.state.areaInfo.pid = item.id;
            this.$store.state.areaInfo.province = item.name;
            this.isArea = false;
            httpPost("/School/get_school", {
                province: this.$store.state.areaInfo.pid,
                institution_type: this.$store.state.type.institution_type,
                disciplinary_level: this.$store.state.type.disciplinary_level
            }).then(response => {
                if (response.code === 1) {
                    this.schoolList = response.list;
                    this.area = !this.area;
                }
            });
        },
        // 选择类型
        chooseType(item) {
           
            this.$store.state.type.institution_type = item.id;
            this.$store.state.type.institution_name = item.name;
            this.isType = false;
            httpPost("/School/get_school", {
                feature_label: this.$store.state.type.labe_id,
                province: this.$store.state.areaInfo.pid,
                institution_type: this.$store.state.type.institution_type,
                disciplinary_level: this.$store.state.type.disciplinary_level
            }).then(response => {
                if (response.code === 1) {
                    this.schoolList = response.list;
                    this.area = !this.area;
                } else {
                    this.schoolList = 0;
                    this.area = !this.area;
                }
            });
        },
        // 选择批次
        choosePici(item) {
            
            this.$store.state.type.disciplinary_level = item.id;
            this.$store.state.type.disciplinary_name = item.name;
            this.isPici = false;
            httpPost("/School/get_school", {
                province: this.$store.state.areaInfo.pid,
                institution_type: this.$store.state.type.institution_type,
                disciplinary_level: this.$store.state.type.disciplinary_level
            }).then(response => {
                if (response.code === 1) {
                    this.schoolList = response.list;
                    this.area = !this.area;
                }
            });
        },
        // 清除批次选择，全部
        resetPici() {
            this.$store.state.type.disciplinary_level = "";
            this.$store.state.type.disciplinary_name = "批次";
            this.isPici = false;
        },
        //返回
        onClickLeft() {
            this.$router.go(-1);
        },
        goSchoolDetail(item) {
           if(item.selecting==0){
               this.$store.state.schoolId = item.id;
                 this.$router.push({
                    path: "/schoolDetail",
                    query: { id: item.id }
                });
           }
          if(item.selecting==1||item.selecting){
                 this.$router.push({
                    path: "/schoolSelectDetail",
                    query: { id: item.id }
                });
           }
            
        },
        //点击展示更多
        showMore(item, index) {
            this.schoolList[index].isOpen = !this.schoolList[index].isOpen;
        },
        //加载学校列表
        loadSchoolList() {
            this.$store.state.type.institution_type = this.$route.query.institution_type;
            this.$store.state.type.labe_id = this.$route.query.labe_id;
            httpPost("/School/get_school", {
                province: this.$store.state.areaInfo.pid,
                city: this.$route.query.city,
                name: this.$route.query.name,
                institution_type: this.$store.state.type.institution_type,
                feature_label: this.$store.state.type.labe_id,
                disciplinary_level: this.$store.state.type.disciplinary_level,
                page: 1
            }).then(response => {
               
                if (response.code === 1) {
                    for (let i = 0; i < response.list.length; i++) {
                        response.list[i].isOpen = false;
                    }
                    this.schoolList = response.list;
                    this.$store.state.searchContent = "";
                    this.$store.state.type.institution_type = "";
                    this.$store.state.type.labe_id = "";
                }
            });
        }
    },
    mounted() {
        this.loadSchoolList();
        // 异步更新数据
        //获取省市信息https://zjnb.720pai.cn/api2//school/get_school_type
        httpPost("/School/condition_all_school", {
            // city: this.$store.state.areaInfo.cid,
            province: this.$store.state.areaInfo.pid,
            institution_type: this.$store.state.type.institution_type,
            disciplinary_level: this.$store.state.type.disciplinary_level
        }).then(response => {
           
            if (response.code === 1) {
                this.areaList = response.region;
                this.typeList = response.institution_type;
            }
        });
    }
};
</script>

<style scoped>
.noPost {
    font-size: 18px;
    text-align: center;
    margin-top: 40px;
}
.header {
    background: #22d9d9;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem;
    color: #fff;
}

.province {
    width: 5rem;
    line-height: 3rem;
    text-align: center;
}

.school-list {
    background: #f2f2f2;
    margin-bottom: 60px;
    /* padding-top: 1rem;
        padding-bottom: 0.1rem; */
}

.school-item,
.school-info {
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    background: #fff;
}

/* .school-item {
        margin-bottom: 1.3rem;
    } */

.school-info {
    margin-top: 1.3rem;
}

.show-more {
    flex-basis: 8vw;
    background: -webkit-linear-gradient(top, #22d9d9, #2aeab5);
    line-height: 6rem;
    font-size: 1.2rem;
    text-align: center;
    color: #fff;
}

.school-name {
    margin-left: 0.5rem;
    padding-top: 1rem;
}

img {
    width: 100%;
    height: 100%;
}

.more {
    flex-basis: 3rem;
    text-align: center;
    line-height: 6rem;
    font-size: 2rem;
}

.more-info {
    background: -webkit-linear-gradient(right, #22d9d9, #2aeab5);
    padding: 0.3rem 8vw;
    color: #fff;
}
.more-info p {
    margin-top: 0.2rem;
}

.school-logo {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    margin-left: 1rem;
    overflow: hidden;
}

.type {
    /* width: 6rem; */
    margin-left: 1rem;
    padding-top: 1rem;
}

.area {
    position: absolute;
    top: 5rem;
    width: 100vw;
    left: 0;
    background: #22d9d9;
    display: flex;
    flex-wrap: wrap;
    padding: 1rem 0;
    justify-content: space-around;
}

.area-province-on,
.area-province {
    color: #fff;
    margin-left: 1rem;
    width: 4rem;
    padding: 0.2rem;
    text-align: center;
    margin-top: 0.5rem;
    border-radius: 0.5rem;
}

.area-province-on {
    color: yellow;
}
</style>
